__webpack_require__.p = "/bans/";